import React, {Component} from "react";
import {CONTROL_PANEL_ROUTE} from "../../../utils/constants/RoutesConstants";
import ExcessLoan from "./ExcessLoanView";
import {MoveGuaranteeService} from "../../../service/controlPanel/MoveGuaranteeService";
import {amountCalculate} from "../../../utils/formatters/Numbers";
import {Growl} from "primereact/growl";
import {GUARANTEE_EXCESS} from "../../../utils/constants/Constants";

export default class ExcessLoanContainer extends Component {
    constructor(props) {
        super(props);

        this.moveGuaranteeService = new MoveGuaranteeService();

        this.loading = this.loading.bind(this);
        this.handleReturnButton = this.handleReturnButton.bind(this);
        this.setGuaranteeE = this.setGuaranteeE.bind(this);

        this.state = {
            isLoading: true,
            selectedLoan: this.props.location.state.selectedLoanControlPanel,
            loanId: this.props.location.state.folio,
            status: this.props.location.state.status,
            loanAmount: this.props.location.state.loanAmount,
            settlementStatusList: [],
        };

        this.loanData = React.createRef();
        this.guaranteeForChange = React.createRef();
    };

    loading(isLoading) {
        if (this.state !== undefined) {
            this.setState({
                isLoading: isLoading
            });
        }
    }

    async componentDidMount() {
        await this.loanData.current.getLoan();
        await this.loanData.current.getRestrictionsLoan(this.state.loanId);
        await this.guaranteeForChange.current.setLoanAmount(this.loanData.current.state.amount);

        await this.guaranteeForChange.current.getGuarantee();
    }

    handleReturnButton(message) {
        this.props.history.push({
            pathname: CONTROL_PANEL_ROUTE,
            message:message,
        });
    }

    setGuaranteeE() {
        let arrayGuarantee = [];
        this.guaranteeForChange.current.state.guaranteeList.map(
            (item) => {
                if (item.newTitles && item.newTitles > 0) {
                    arrayGuarantee.push({
                        idEmisora: item.idEmisora,
                        titulos: item.newTitles,
                        idOperacion: GUARANTEE_EXCESS
                    });
                }
                return '';
            });

        if (
            arrayGuarantee.length === 0 ||
            this.loanData.current.state.amount >
            amountCalculate(this.guaranteeForChange.current.state.guaranteeAmountTotal)) {
            this.growl.show({severity: 'error', summary: 'Error.', detail: "Favor de validar las garantías"});
        } else {
            this.loading(true);
            this.moveGuaranteeService.setGuaranteeE(
                this.state.loanId,
                this.state.status,
                arrayGuarantee
            ).then(response => {
                this.loading(false);
                if (response.error !== "") {
                    this.growl.show({severity: 'error', summary: 'Error.', detail: response.error});
                } else {
                    this.handleReturnButton({
                        severity: 'success',
                        sumary: 'Éxito',
                        detail: 'Las garantías se han retirado exitosamente',
                    });
                }
            });
        }
    }

    render() {
        let messagesGrowl = <Growl ref={(el) => this.growl = el}/>;

        return <ExcessLoan
            isLoading={this.state.isLoading}
            loading={this.loading}
            messagesGrowl={messagesGrowl}
            loanData={this.loanData}
            handleReturnButton={this.handleReturnButton}
            setGuaranteeE={this.setGuaranteeE}
            guaranteeForChange={this.guaranteeForChange}
            selectedLoan={this.state.selectedLoan}
            loanId={this.state.loanId}
            loanAmount={this.state.loanAmount}
        />

    }
};